export default __webpack_public_path__ + "static/media/gallery_04.bc9965fb.jpg";